import React from 'react';
import { X, Download, Share } from 'lucide-react';
import usePWAInstall from '../hooks/usePWAInstall';

export default function PWAInstallBanner() {
  const { canInstall, isInstalled, isIOS, showIOSBanner, promptInstall, dismiss } = usePWAInstall();

  if (!canInstall || isInstalled) return null;

  // iOS Safari: manual "Add to Home Screen" instructions
  if (isIOS && showIOSBanner) {
    return (
      <div className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:max-w-sm animate-slideUp">
        <div className="relative rounded-2xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/20 shadow-lg p-4">
          <button
            onClick={dismiss}
            className="absolute top-3 right-3 p-1 rounded-lg hover:bg-white/10 transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4 text-gray-400" />
          </button>
          <div className="flex items-start gap-3 pr-6">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-lg">N</span>
            </div>
            <div>
              <p className="font-semibold text-white text-sm">Install APD NEXUS</p>
              <p className="text-gray-400 text-xs mt-1 leading-relaxed">
                Tap <Share className="w-3 h-3 inline text-blue-400" /> then
                <span className="font-medium text-white"> "Add to Home Screen"</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Chromium browsers: install prompt button
  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:max-w-sm animate-slideUp">
      <div className="relative rounded-2xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/20 shadow-lg p-4">
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 p-1 rounded-lg hover:bg-white/10 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>
        <div className="flex items-center gap-3 pr-6">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center flex-shrink-0">
            <span className="text-white font-bold text-lg">N</span>
          </div>
          <div className="flex-1">
            <p className="font-semibold text-white text-sm">Install APD NEXUS</p>
            <p className="text-gray-400 text-xs">Access services offline</p>
          </div>
          <button
            onClick={promptInstall}
            className="px-3 py-2 rounded-xl bg-gradient-to-r from-violet-500 to-purple-600 text-white text-xs font-medium flex items-center gap-1.5 hover:shadow-lg hover:shadow-violet-500/30 transition-all flex-shrink-0"
          >
            <Download className="w-3.5 h-3.5" />
            Install
          </button>
        </div>
      </div>
    </div>
  );
}
